import { render, staticRenderFns } from "./SoundSetting.vue?vue&type=template&id=8fd6bb60&"
import script from "./SoundSetting.vue?vue&type=script&lang=js&"
export * from "./SoundSetting.vue?vue&type=script&lang=js&"
import style0 from "./SoundSetting.vue?vue&type=style&index=0&id=8fd6bb60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports